// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RedditOutlinedSvg from "@fishx/icons-svg/es/asn/RedditOutlined";
import FishxIcon from '../components/FishxIcon';

var RedditOutlined = function RedditOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RedditOutlinedSvg
  }));
};

RedditOutlined.displayName = 'RedditOutlined';
export default React.forwardRef(RedditOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RedditOutlined.js
// module id = 3992
// module chunks = 0